import { injectIntl } from "react-intl";
import React, { useState } from "react";
import { OperationType } from "src/helpers/Enums";
import apiService from "src/services/api.service";

const AddPricing = (props) => {
  const getCostValue = (pricing) => pricing?.cost_per_message;

  const [pricing, setPricing] = useState(
    props.type === OperationType.UPDATE
      ? {
          _id: props.pricing?._id,
          cost_per_message:
            getCostValue(props.pricing) != null
              ? String(getCostValue(props.pricing))
              : "",
          notes: props.pricing?.notes || "",
        }
      : { cost_per_message: "", notes: "" }
  );

  const handleCost = (value) => {
    setPricing({ ...pricing, cost_per_message: value });
  };

  const handleNotes = (value) => {
    setPricing({ ...pricing, notes: value });
  };

  const createUpdatePricing = () => {
    const payload = {
      ...pricing,
      cost_per_message: parseFloat(pricing.cost_per_message),
    };

    switch (props.type) {
      case OperationType.CREATE:
        apiService.createSmsPricing(payload).then(() => {
          props.close();
        });
        break;
      case OperationType.UPDATE:
        apiService.updateSmsPricing(payload).then(() => {
          props.close();
        });
        break;
      default:
        break;
    }
  };

  const isEnableButton = () => {
    const cost = parseFloat(pricing?.cost_per_message);
    return !isNaN(cost) && cost > 0;
  };

  const isCreate = props.type === OperationType.CREATE;

  return (
    <div className="NewStrategyModalOverlay z-[999]">
      <div className="NewStrategyModal">
        <div className="w-full flex justify-between">
          <div className={isCreate ? "NewStrategy" : "NewCreative"}>
            <img
              alt="Logo"
              src={
                isCreate
                  ? "/media/icons/purplePlusIcon.svg"
                  : "/media/icons/editIcon.svg"
              }
              className="w-[18px] h-[18px]"
            />
            {isCreate ? "Add Pricing" : "Edit Pricing"}
          </div>
          <button
            type="button"
            className="CloseIconButton"
            onClick={props.close}
          >
            <img
              alt="Close"
              src="/media/icons/closeIcon.svg"
              className="w-5 h-5"
            />
          </button>
        </div>

        <div className="HorizontalDivider"></div>

        <div className="NewStrategyInputSection">
          <div className="NewStrategyInputTitle">Cost Per Message ($)</div>
          <input
            className="NewStrategyInput"
            type="number"
            step="0.0001"
            min="0"
            placeholder="Enter"
            onChange={(e) => handleCost(e.target.value)}
            value={pricing?.cost_per_message}
          />
          <div className="SettingsInputHint">Base cost charged per message</div>
        </div>

        <div className="NewStrategyInputSection hasTextarea">
          <div className="NewStrategyInputTitle">Notes (Optional)</div>
          <textarea
            className="NewStrategyTextarea"
            placeholder="Enter"
            onChange={(e) => handleNotes(e.target.value)}
            value={pricing?.notes}
          />
        </div>

        <div className="HorizontalDivider"></div>

        <div className="modal-actions">
          <button type="button" onClick={props.close} className="CloseButton">
            Close
          </button>
          <button
            type="button"
            className="CreateButton"
            disabled={!isEnableButton()}
            onClick={createUpdatePricing}
          >
            {isCreate ? "Add Pricing" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(AddPricing);
